import { yupResolver } from "@hookform/resolvers/yup";
import { useMutation } from "@tanstack/react-query";
import { useAuth } from "contexts/AuthContext";
import { useToast } from "contexts/ToastContext";
import { useForm } from "react-hook-form";
import { ForgotPasswordFormType } from "types";
import { forgotPasswordSchema } from "validations";

export const useForgotPassword = () => {
  const { forgotPassword } = useAuth();
  const { showError } = useToast();

  const methods = useForm<ForgotPasswordFormType>({
    resolver: yupResolver(forgotPasswordSchema),
    mode: "onChange",
  });

  const mutation = useMutation({
    mutationFn: (email: string) => forgotPassword(email),
    onError: (error: unknown) => {
      const errorMessage =
        error instanceof Error
          ? error.message
          : "Reset password failed. Please try again.";
      showError("Reset password failed", errorMessage);
    },
  });

  const onSubmit = methods.handleSubmit(
    async (data: ForgotPasswordFormType) => {
      mutation.mutate(data.email);
    },
  );

  return {
    methods,
    onSubmit,
    isSubmitting: mutation.isPending,
    isSuccess: mutation.isSuccess,
    resetMutation: mutation.reset,
  };
};
